import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import LoadingSpinner from "../LoadingSpinner";
import Dropdown from "../input/Dropdown";
import Input from "../input/Input";
import { stakeholderGroupValidation } from "../validations/StakeholderGroupCreation";
import InfoList from "../InfoList";
import { formatFromJsonDate } from "../../dateConfig";
import { User } from "react-feather";
import { FORMS, MODULES } from "../../const";
import useUserCompany from "../../hooks/useUserCompany";

const FORM = FORMS.STAKEHOLDER_GROUP.GRP.form;

const StakeholderGroupComponent = forwardRef(
  ({ errors, dropdown, isLoading, currentValues, editMode }, ref) => {
    const userCompany = useUserCompany();
    
            const [company, setCompany] = useState(
                userCompany ? userCompany.comId : null
            );
    
            useEffect(() => {
                setCompany(userCompany ? userCompany.comId : null);
            }, [userCompany]);
            
    const [stakeholderGroupData, setStakeholderGroupData] = useState(
      editMode
        ? {
            ...currentValues,
            // grpGroupCategory: currentValues.
          }
        : {
            grpCode: "",
            grpGroup: "",
            grpGroupCategory: "",
            grpDescription: "",
            grpStatus: 2,
            grpActive: 1,
            grpCompany:company,
          }
    );
    const [currentErrors, setCurrentErrors] = useState({});
    useEffect(() => {
      setCurrentErrors(errors);
    }, [errors]);

    useImperativeHandle(ref, () => ({
      getData: () => stakeholderGroupData,
      validateForm: () => {
        return stakeholderGroupValidation(stakeholderGroupData);
      },
      resetForm: () => {
        setStakeholderGroupData({
          grpCode: "",
          grpGroup: "",
          grpGroupCategory: "",
          grpDescription: "",
          grpStatus: 2,
          grpActive: 1,
        });
      },
    }));


    const [stakeholderName, setStakeholderName] = useState("");
    const [stakeholderCode, setStakeholderCode] = useState("");
    const [description, setDescription] = useState("");
    const [active, setActive] = useState("");
    const [type, setType] = useState("");

    const [searchFieldReset, setSearchFieldReset] = useState(false);

    const handleReset = () => {
      setStakeholderName("");
      setStakeholderCode("");
      setDescription("");
      setActive("");
    };
    return (
      <>
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <form
            className="ui form"
            style={{ overflowY: "auto", height: "75vh" }}
          >
            <div className="ui segment">
              <h4 className="ui deviding header">Stakeholder Group</h4>
              <div className="two fielda">
                <Input
                  label="Stakeholder Group Code"
                  error={currentErrors.grpCode}
                  module={MODULES.Master}
                  form={FORM}
                  field="grp_code"
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { grpCode: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  name="stakeholderGroupCode"
                  value={stakeholderGroupData.grpCode}
                  onChange={(e) => {
                    setStakeholderGroupData((prevState) => ({
                      ...prevState,
                      grpCode: e.target.value,
                    }));
                  }}
                  disabled={true}
                />
              </div>
              <div className="two fields">
                <Input
                  required={true}
                  label="Stakeholder Group Name"
                  placeholder="Group Name"
                  module={MODULES.Master}
                  form={FORM}
                  field="grp_group"
                  editMode={editMode}
                  error={currentErrors.grpGroup}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { grpGroup: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  name="stakeholderGroupName"
                  value={stakeholderGroupData.grpGroup}
                  onChange={(e) => {
                    setStakeholderGroupData((prevState) => ({
                      ...prevState,
                      grpGroup: e.target.value,
                    }));
                  }}
                />
                <Dropdown
                  label="Category"
                  error={currentErrors.grpGroupCategory}
                  module={MODULES.Master}
                  form={FORM}
                  field="grp_group_category"
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { grpGroupCategory: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  placeholder="Category"
                  options={dropdown.categoryTypeOptions}
                  value={stakeholderGroupData.grpGroupCategory}
                  style={{ height: "20px" }}
                  onChange={(e, data) => {
                    setStakeholderGroupData((prevState) => ({
                      ...prevState,
                      grpGroupCategory: data.value,
                    }));
                  }}
                />
              </div>
              <div className="two fields">
                <div
                  className={`field ${
                    currentErrors.grpDescription ? "error" : ""
                  }`}
                >
                  <Input
                    name="stakeholderGroupDescription"
                    label="Description"
                    module={MODULES.Master}
                    form={FORM}
                    field="grp_description"
                    editMode={editMode}
                    placeholder="Description"
                    error={currentErrors.grpDescription}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { grpDescription: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                    value={stakeholderGroupData.grpDescription}
                    onChange={(e) => {
                      setStakeholderGroupData((prevState) => ({
                        ...prevState,
                        grpDescription: e.target.value,
                      }));
                    }}
                  />
                </div>
              </div>
              <div className="two fields">
                <Dropdown
                  required={true}
                  label="Status"
                  module={MODULES.Master}
                  form={FORM}
                  field="grp_status"
                  editMode={editMode}
                  error={currentErrors.grpStatus}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { grpStatus: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  placeholder="Status"
                  options={dropdown.stkGroupStatusOpt}
                  value={stakeholderGroupData.grpStatus}
                  style={{ height: "20px" }}
                  onChange={(e, data) => {
                    setStakeholderGroupData((prevState) => ({
                      ...prevState,
                      grpStatus: data.value,
                    }));
                  }}
                />
                <Dropdown
                  required={true}
                  label="Active"
                  module={MODULES.Master}
                  form={FORM}
                  field="grp_active"
                  authenticated={true}
                  needDeletePermission={true}
                  editMode={editMode}
                  error={currentErrors.grpActive}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { grpActive: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  placeholder="Active"
                  options={dropdown.stkGroupActiveOpt}
                  value={stakeholderGroupData.grpActive}
                  style={{ height: "20px" }}
                  onChange={(e, data) => {
                    setStakeholderGroupData((prevState) => ({
                      ...prevState,
                      grpActive: data.value,
                    }));
                  }}
                />
              </div>
            </div>
            {editMode && (
              <InfoList
                title="User Information"
                content={[
                  {
                    title: "Created By",
                    value: stakeholderGroupData.createdBy
                      ? stakeholderGroupData.createdBy
                      : "N/A",
                  },
                  {
                    title: "Created Date",
                    value: stakeholderGroupData.createdDate
                      ? formatFromJsonDate(stakeholderGroupData.createdDate)
                      : "N/A",
                  },
                  {
                    title: "Last Modified By",
                    value: stakeholderGroupData.lastModifiedBy
                      ? stakeholderGroupData.lastModifiedBy
                      : "N/A",
                  },
                  {
                    title: "Last Modified Date",
                    value: stakeholderGroupData.lastModifiedDate
                      ? formatFromJsonDate(
                          stakeholderGroupData.lastModifiedDate
                        )
                      : "N/A",
                  },
                ]}
                Icon={User}
              />
            )}
          </form>
        )}
      </>
    );
  }
);

export default StakeholderGroupComponent;
